import {UrlServices, FRONTEND_URL} from '~/utils/url-manager'
import i18n from '~/i18n'

const Index =  [
    //{ header: 'Apps' },
    // {
    //     title: i18n.t('menu.home'),
    //     icon: 'fas fa-home',
    //     name: 'admin',
    //     route: UrlServices.getRouteObject({'name': 'admin'})
    // },
    {
        title: 'menu.events',
        icon: 'far fa-calendar-alt',
        items: [
            {
                name: 'poll_list',
                title: 'menu.pre_event_poll',
                route: UrlServices.getRouteObject({'name': 'poll_list'})
            },
            {
                name: 'event_list',
                title: 'menu.event_list',
                route: UrlServices.getRouteObject({'name': 'event_list'})
            }
        ]
    },
    {
        title: 'menu.contacts',
        icon: 'fa-address-book',
        items: [
            {
                name: 'contact_list',
                title: 'menu.all_contacts',
                route: UrlServices.getRouteObject({'name': 'contact_list'})
            },
            {
                name: 'contact_group',
                title: 'menu.groups',
                route: UrlServices.getRouteObject({'name': 'contact_group'})
            }
        ]
    },
    {
        title: 'menu.teams',
        icon: 'fas fa-user-friends',
        items: [
            {
                name: 'team_list',
                title: 'menu.team_list',
                route: UrlServices.getRouteObject({'name': 'team_list'})
            }
        ]
    }
    //{
    //    title: 'menu.agents',
    //    icon: 'fa-user-cog',
    //    route: UrlServices.getRouteObject({'name': 'agent_list'})
    //}
];
// reorder menu
// Index.forEach((item) => {
//     if (item.items) {
//         item.items.sort((x, y) => {
//             let textA = x.title.toUpperCase();
//             let textB = y.title.toUpperCase();
//             return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
//         });
//     }
// });

export default Index;